import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ListItemIcon, ListItemText, MenuItem } from '@material-ui/core';
import { FileCopy } from '@material-ui/icons';
import { useSnackbar } from 'notistack';
import { CentralProviderContext } from '../../../centralProviderContext/CentralProviderContext';
import { ShareValues } from '../../../helpers/ShareValues';
import { apiGateway } from '../../../environment.vars';
export function CopyBearerToken(_a) {
    var closeDropdown = _a.closeDropdown;
    var contextValue = useContext(CentralProviderContext);
    var t = useTranslation().t;
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    if (!contextValue || !contextValue.centralProfile)
        return null;
    var handleClick = function () {
        navigator.clipboard.writeText(ShareValues.getAuthResultTokenAccess() || '');
        enqueueSnackbar(t('Bearer token copied'), {
            variant: 'success',
            autoHideDuration: 2000,
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'right',
            },
        });
        closeDropdown();
    };
    if (!apiGateway.includes('.integration.') && apiGateway.includes('.test.')) {
        return null;
    }
    return (React.createElement(MenuItem, { onClick: handleClick },
        React.createElement(ListItemIcon, { style: { minWidth: '33px' } },
            React.createElement(FileCopy, { color: "primary" })),
        React.createElement(ListItemText, { primary: t('Copy Bearer Token') })));
}
//# sourceMappingURL=CopyBearerToken.js.map